// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultProbeSetState } from "../rna-fish/EditKitForm";
import { probeKitToProbeFormState } from "../rna-fish/RnaFishKitToFormState";
import { defaultBufferState, defaultDetectState } from "./ManualProConsumerKitForm";
export var manualProKitToConsumerFormState = function (catalog, kit) {
    var _a, _b, _c, _d, _e, _f;
    // probe set
    var probeSetEnabled = false;
    var probeSetState = defaultProbeSetState(catalog, false, true);
    if (kit.probeSet !== undefined) {
        probeSetEnabled = true;
        probeSetState = probeKitToProbeFormState(probeSetState, kit.probeSet, catalog, false, undefined, undefined)[0];
    }
    var detectEnabled = false;
    var detectState = defaultDetectState(catalog);
    if (kit.detect !== undefined) {
        var proAmpCatalog = catalog.proAmplifier;
        // Currently no multiplex so only looking at the first channel
        var detectChannel_1 = kit.detect.channels[0];
        var enzyme = (_a = proAmpCatalog.manualProAmps.proAmpConfigList.find(function (a) {
            var _a, _b, _c;
            return ((_a = detectChannel_1.hcrAmplifier) === null || _a === void 0 ? void 0 : _a.id) === a.amplifier.id &&
                ((_b = detectChannel_1.hapten) === null || _b === void 0 ? void 0 : _b.id) === a.hapten.id &&
                ((_c = detectChannel_1.enzyme) === null || _c === void 0 ? void 0 : _c.id) === a.enzyme.id &&
                detectChannel_1.channel === a.channelNum;
        })) !== null && _a !== void 0 ? _a : proAmpCatalog.manualProAmps.proAmpConfigList.find(function (a) { return a.isDefault; });
        var scale = (_d = (_c = (_b = kit.detect.presetScale) === null || _b === void 0 ? void 0 : _b.units) !== null && _c !== void 0 ? _c : kit.detect.customScale) !== null && _d !== void 0 ? _d : catalog.defaultManualProScale;
        detectEnabled = true;
        detectState = __assign(__assign({}, detectState), { enzyme: enzyme,
            scale: scale, 
            // TODO for preset scales make sure the preset scale can be found in the catalog otherwise apply a default,
            //  technically the preset scale can be inactive at a certain point so we'll need to assert it's validity
            presetDetectScale: kit.detect.presetScale });
        if (!probeSetEnabled) {
            probeSetState = __assign(__assign({}, probeSetState), { hcrAmplifier: detectState.enzyme.amplifier });
        }
        if (((_e = kit.chromogen) === null || _e === void 0 ? void 0 : _e.chromogen) !== undefined) {
            detectState = __assign(__assign({}, detectState), { chromogen: kit.chromogen.chromogen, presetChromogenScale: kit.chromogen.presetScale });
        }
        else {
            detectState = __assign(__assign({}, detectState), { chromogen: {
                    id: 'NONE',
                    label: 'NONE',
                    platformCompatibility: [],
                    enzymeCompatibility: '',
                    bufferCompatibility: { id: 'NONE', label: 'NONE' }
                } });
        }
    }
    // buffer set
    var buffersEnabled = false;
    var bufferState = defaultBufferState(catalog);
    if (kit.buffers !== undefined) {
        buffersEnabled = true;
        bufferState = __assign(__assign({}, bufferState), { hybridization: kit.buffers.hybridizationBuffer, probeWash: kit.buffers.probeWashBuffer, ampWash: kit.buffers.ampWashBuffer });
    }
    var sampleTypeFormState = {
        sampleType: (_f = catalog.manualProBuffer.sampleTypes.find(function (t) { return t.id === kit.sampleType.id; })) !== null && _f !== void 0 ? _f : catalog.manualProBuffer.defaultSampleType
    };
    return {
        detectEnabled: detectEnabled,
        detectState: detectState,
        buffersEnabled: buffersEnabled,
        bufferState: bufferState,
        comment: kit.comment,
        errors: [],
        price: undefined,
        priceLoading: false,
        probeSetEnabled: probeSetEnabled,
        probeSetState: probeSetState,
        sampleTypeFormState: sampleTypeFormState
    };
};
//# sourceMappingURL=ManualProKitToConsumerFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/ManualProKitToConsumerFormState.js
// module id = 598
// module chunks = 0